module.exports = __webpack_public_path__ + "static/icon_download_QR-932f26963d2c8ec1cc320bce995e5c9a.jpg";